import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import "./App.css";
import MainLayOut from "./component/MainLayOut";
import { useEffect } from "react";
import Home from "./pages/Home";
import ContactUs from "./pages/contact-us/ContactUs";
import Gallery from "./pages/gallery/Gallery";
import Blog from "./pages/blog/Blog";
import About from "./pages/about/About";
import TrackOrder from "./pages/track/TrackOrder";
import ProductDetails from "./pages/product/ProductDetails";


function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}
function App() {
  return (
    <div>
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" exact element={<MainLayOut />}>
            <Route index element={<Home />} />
            <Route path="/contact-us" element={<ContactUs />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/about-us" element={<About />} />
            <Route path="/track-order" element={<TrackOrder />} />
            <Route path="/product-details" element={<ProductDetails />} />

          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
